<tt-page *ngIf="!!setting">
    <tt-page-heading *ngIf="!!setting.webpage_heading" [ttModel]="setting.webpage_heading"></tt-page-heading>
    <tt-list class="col-xs-12 col-md-4 sp-0" [ttData]="itemsListProjectActivityTypes" [ttBadge]="'badge'"></tt-list>
</tt-page>
